import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import { WindowModule, WINDOW } from '@upr-web-primer/window';
import * as i1 from '@upr-web-primer/storage';
import { get } from 'lodash-es';
class LocaleModule {
  static {
    this.ɵfac = function LocaleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LocaleModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LocaleModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [WindowModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocaleModule, [{
    type: NgModule,
    args: [{
      imports: [WindowModule]
    }]
  }], null, null);
})();
class LocaleService {
  constructor(defaultLanguage, defaultCountry, window, localStorage, sessionStorage) {
    this.defaultLanguage = defaultLanguage;
    this.defaultCountry = defaultCountry;
    this.window = window;
    this.localStorage = localStorage;
    this.sessionStorage = sessionStorage;
    this.init();
  }
  init() {
    const locale = this.getFromUrl();
    this.setStorage(locale);
  }
  getFromUrl() {
    let groups = this.window.location.pathname.match(/(\/[a-zA-Z]{2})+(\/[a-zA-Z]{2})+(\/.*)/i);
    if (!groups) {
      groups = this.window.location.pathname.match(/(\/[a-zA-Z]{2})+(\/[a-zA-Z]{2})+(.*)/i);
    }
    let language = this.defaultLanguage;
    let country = this.defaultCountry;
    if (groups) {
      language = get(groups, '1', language).replace('/', '');
      country = get(groups, '2', country).replace('/', '');
    }
    return {
      language,
      country
    };
  }
  getFromString(path) {
    const groups = path.match(/\/([a-zA-Z]{2}\/[a-zA-Z]{2})(\/|$)/);
    let language = this.defaultLanguage;
    let country = this.defaultCountry;
    if (groups) {
      const split = get(groups, '1', `${country}/${language}`).split('/');
      language = split[1];
      country = split[0];
    }
    return {
      language,
      country
    };
  }
  getFromStorage() {
    return {
      language: this.sessionStorage.getItem('language') || this.localStorage.getItem('language') || this.defaultLanguage,
      country: this.sessionStorage.getItem('country') || this.localStorage.getItem('country') || this.defaultCountry
    };
  }
  setStorage(locale) {
    const language = get(locale, 'language', this.defaultLanguage);
    const country = get(locale, 'country', this.defaultCountry);
    this.sessionStorage.setItem('language', language);
    this.sessionStorage.setItem('country', country);
    this.localStorage.setItem('language', language);
    this.localStorage.setItem('country', country);
  }
  static {
    this.ɵfac = function LocaleService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LocaleService)(i0.ɵɵinject('DefaultLanguage'), i0.ɵɵinject('DefaultCountry'), i0.ɵɵinject(WINDOW), i0.ɵɵinject(i1.LocalStorageService), i0.ɵɵinject(i1.SessionStorageService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LocaleService,
      factory: LocaleService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocaleService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['DefaultLanguage']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['DefaultCountry']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }, {
    type: i1.LocalStorageService
  }, {
    type: i1.SessionStorageService
  }], null);
})();

/*
 * Public API Surface of locale
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LocaleModule, LocaleService };
